import type {ComponentPropsWithRef} from 'react';
import React from 'react';

import {Scroll} from '@pb/kit-component-scroll';
import {hashedClasses, withCssModule} from '@pb/kit-util-with-css-module';

import styles from '../../dialog.module.styl';

import type {ScrollProps} from '@pb/kit-component-scroll';

const classes = hashedClasses(styles);
const classNames = withCssModule(styles);

export type DialogMainProps = ScrollProps & {
    /**
     * Native `<div>` props forwarded to the outer wrapper element that constrains
     * the scrollable area (e.g. `className`, `style`, `data-testid`). The dialog-main
     * CSS class is applied; additional `className` is merged, not replaced.
     */
    rootProps?: ComponentPropsWithRef<'div'>,
};

/**
 * Scrollable body region for `<Dialog>` and `<AlertDialog>` panels.
 *
 * Wraps `children` in a `<Scroll>` component so long content scrolls inside the
 * dialog rather than growing the panel beyond the viewport. Place between
 * `<DialogHeader>` and `<DialogFooter>` for the standard dialog layout.
 * Pass any `<Scroll>` props to customize scroll behavior.
 */
export const DialogMain = ({rootProps, children, ...props}: DialogMainProps) => {

    return (
        <div {...rootProps} className={classNames(classes['dialog-main'], rootProps?.className)}>
            <Scroll {...props}>
                {children}
            </Scroll>
        </div>
    );
};

DialogMain.displayName = 'DialogMain';
